import { FEATURES } from "@/mocks/ecfMocks";

export default function FeaturesSection() {
  return (
    <section id="producto" className="bg-slate-50 py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-flex items-center px-3 py-1 rounded-full border border-slate-300 text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
            Por qué elegirnos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Todo lo que necesitas para emitir<br />comprobantes fiscales a escala
          </h2>
          <p className="text-slate-500 text-lg max-w-xl mx-auto">
            El ciclo completo de tu negocio integrado y automatizado.
          </p>
        </div>

        {/* Comparación Banner */}
        <div className="max-w-4xl mx-auto bg-white border border-blue-100 rounded-2xl p-6 md:p-8 mb-16 shadow-sm">
          <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
            💡 La alternativa al Facturador Gratuito y los POS tradicionales
          </h3>
          <p className="text-sm leading-relaxed text-slate-600 mb-4">
            El facturador gratuito de la DGII emite facturas, pero no controla tu inventario, no registra tus compras, no genera tus reportes 606/607, y solo lo usa una persona a la vez. Por otro lado, un POS básico controla la caja, pero no sabe lo que tienes en el almacén ni lo que le debes a tus proveedores.
          </p>
          <p className="text-sm font-semibold text-slate-900 border-l-4 border-blue-600 pl-3">
            <strong>emite.do</strong> te entrega el ciclo de negocio completo (compras, inventario, ventas, punto de venta y facturación electrónica homologada) por el precio de un POS convencional.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className="group bg-white border border-slate-100 rounded-2xl p-7 hover:bg-blue-800 transition-all duration-200 cursor-default"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-10 h-10 flex items-center justify-center bg-slate-100 group-hover:bg-white/20 rounded-xl transition-colors">
                  <f.icon className="text-xl text-blue-800 group-hover:text-white transition-colors" />
                </div>
                <span className="text-xs font-semibold text-slate-400 group-hover:text-white/70 bg-slate-50 group-hover:bg-white/10 px-2.5 py-1 rounded-full transition-colors whitespace-nowrap">
                  {f.tag}
                </span>
              </div>
              <h3 className="text-base font-bold text-slate-900 group-hover:text-white mb-2 transition-colors">
                {f.title}
              </h3>
              <p className="text-sm text-slate-500 group-hover:text-white/80 leading-relaxed transition-colors">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}